import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import store from '@ps/store';
import { findByUuid } from '@ps/bridge/qc/node/utils';
import * as sceneConfigScript from '@ps/bridge/qc/scripts/scene-config';
import { getSceneNodeByUuid } from '@ps/bridge/qc/base';

export default {
  name: 'scene-node',

  props: {
    nodeId: {
      type: String,
      required: true
    }
  },

  inject: ['getGraph', 'getNode'],

  data: function data() {
    return {
      node: {}
    };
  },


  computed: {
    currentX6id: function currentX6id() {
      return (store.state.workspace.storyboard.currentX6Node || {}).id;
    },
    currentSceneId: function currentSceneId() {
      var scene = getSceneNodeByUuid(this.currentX6id);
      return scene ? scene.uuid : '';
    },
    isEditScene: function isEditScene() {
      return store.state.workspace.storyboard.isEditScene;
    },
    thumbnail: function thumbnail() {
      var data = store.state.workspace.sceneManager.sceneThumbnail[this.nodeId];
      if (!data || !data.thumbnail) return '';
      return data['thumbnail'][this.orientation === 1 ? 'portrait' : 'horizontal'];
    },
    orientation: function orientation() {
      return store.state.workspace.game.device.orientation;
    },
    config: function config() {
      return this.getSceneData(this.nodeId);
    }
  },

  methods: {
    getSceneData: function getSceneData(uuid) {
      var node = findByUuid(uuid);
      if (!node) {
        console.warn('没有找到该 id');
        return {};
      }
      this.node = node;
      var isEnding = sceneConfigScript.getScript(node).isEnding;
      return {
        type: isEnding ? 'ending' : '',
        name: node.uniqueName
      };
    },
    toggle: function toggle(val) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var sceneId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!val) {
                  _context.next = 10;
                  break;
                }

                sceneId = store.state.workspace.sceneManager.currentSceneNode.uuid;
                _context.next = 4;
                return store.dispatch('workspace/storyboard/exitEditScene', {
                  sceneId: sceneId,
                  id: sceneId
                });

              case 4:
                _context.next = 6;
                return store.dispatch('workspace/storyboard/renderDagNodes');

              case 6:
                _context.next = 8;
                return store.dispatch('workspace/storyboard/renderEdges', {
                  sceneId: sceneId,
                  id: sceneId
                });

              case 8:
                _context.next = 14;
                break;

              case 10:
                _context.next = 12;
                return store.dispatch('workspace/storyboard/editTargetScene', {
                  sceneId: _this.nodeId
                });

              case 12:
                _context.next = 14;
                return store.commit('workspace/storyboard/moveSceneEditorToTargetScenePosition', { sceneId: _this.nodeId });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};